import PresetApi from '@/api/preset'

const _state = {
  colorPalettes: [],
}

const mutations = {
  setColorPalettes(state, payload) {
    state.colorPalettes = payload
  },
}

const actions = {
  async getPresetColorPalettesAction({ state, commit }) {
    if (state.colorPalettes.length) return state.colorPalettes
    const resp = await PresetApi.getPresetColorPalettes()
    const colorPalettes = resp.body
    commit('setColorPalettes', colorPalettes)
    return colorPalettes
  },
}

const _getters = {
  presetColorPalettes: (state) => {
    return state.colorPalettes
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters: _getters,
}
